// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5ebf0b4b","239":"3546777b","455":"84c5e31d","762":"fced9e0b"}[chunkId] + ".chunk.js";
};